import React from "react";
import { createRoot } from "react-dom/client";
//Buffer needs this to work in the CI/CD builds
import { Buffer as BufferPolyfill } from "buffer";
import "./main.css";
import { App, AppProviders } from "./App";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare const Buffer: typeof BufferPolyfill;
globalThis.Buffer = BufferPolyfill;

const domElement = document.getElementById("root");

if (domElement) {
  createRoot(domElement).render(
    <React.StrictMode>
      <AppProviders>
        <App />
      </AppProviders>
    </React.StrictMode>,
  );
}
